import { render, staticRenderFns } from "./smallBagShip.vue?vue&type=template&id=016868b3&scoped=true&"
import script from "./smallBagShip.vue?vue&type=script&lang=js&"
export * from "./smallBagShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016868b3",
  null
  
)

export default component.exports